import styled from 'styled-components';
import { Button, ButtonStyle } from './Button';
import { ReactNode } from 'react';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const ButtonGrey = styled.button<{
  selected: boolean;
  $position: 'left' | 'right';
}>`
  ${ButtonStyle({ $size: 'M' })}
  cursor: pointer;
  border: 0;
  background-color: ${(props) =>
    props.selected ? props.theme.color.green : props.theme.color.grey};
  border-left: 0.3vmin solid transparent;
  border-right: 0.3vmin solid transparent;
  opacity: ${(props) => (props.selected ? 1 : '0.5')};
  transform: skew(-5deg);

  &:hover {
    opacity: 1;
  }
`;
const ButtonGreyContent = styled.div`
  transform: skew(5deg);
`;

const Toggle = ({
  selected,
  position,
  children,
  onClick,
}: {
  selected: boolean;
  position: 'left' | 'right';
  children?: ReactNode;
  onClick: () => void;
}) => {
  return selected ? (
    <Button color="green" onClick={onClick}>
      {children}
    </Button>
  ) : (
    <ButtonGrey selected={false} $position={position} onClick={onClick}>
      <ButtonGreyContent>{children}</ButtonGreyContent>
    </ButtonGrey>
  );
};

export const ButtonToggle = <T,>({
  value,
  values,
  onClick,
}: {
  value: T;
  values: { value: T; children: ReactNode }[];
  onClick: (value: T) => void;
}) => {
  return (
    <Wrapper>
      {values.map((v, i) => (
        <Toggle
          key={i}
          selected={v.value === value}
          position="left"
          onClick={() => {
            onClick(v.value);
          }}
        >
          {v.children}
        </Toggle>
      ))}
    </Wrapper>
  );
};
